import { orderConstants, cartConstants, userConstants } from '../constants';

const {
  CART_STATUS_CURRENT,
  CART_STATUS_CURRENT_PREORDER,
  CART_STATUS_MOQ_STAND_BY,
  CART_STATUS_MOQ_PREORDER,
} = cartConstants;
const {
  ORDER_STATUS_APPROVED,
  ORDER_STATUS_PENDING_VALIDATION,
  ORDER_STATUS_FACTURED,
  PREORDER_STATUS_APPROVED,
  STATUS_ORDER_DELIVERED,
  ORDER_FACTURED_ITEMS,
  STATUS_CREDIT,
} = orderConstants;
const { TYPE_CUSTOMER } = userConstants;

// Platform ids or ext_codes for which the "Renouveler" button is hidden.
const RENEW_DISABLED_PLATFORM_IDS = [];
const RENEW_DISABLED_PLATFORM_EXT_CODES = [111];
const RENEW_CUTOFF_DATE = '2026-03-24';

export function isRenewDisabledForPlatform(platform) {
  return (
    platform &&
    (RENEW_DISABLED_PLATFORM_IDS.some((id) => Number(id) === Number(platform.id)) ||
      RENEW_DISABLED_PLATFORM_EXT_CODES.some(
        (code) =>
          (platform.ext_code || '').toString().toLowerCase() ===
          (code || '').toString().toLowerCase()
      ))
  );
}

export function isRenewDisabledForOrder(platform, orderDate) {
  if (!isRenewDisabledForPlatform(platform)) return false;
  // Lexicographic comparison works because dates are ISO 8601 (YYYY-MM-DD)
  return typeof orderDate === 'string' && orderDate.slice(0, 10) <= RENEW_CUTOFF_DATE;
}

export function convertListStatus(status, userType) {
  switch (status) {
    case ORDER_STATUS_PENDING_VALIDATION:
      return 'Commandes en attente de validation';
    case ORDER_STATUS_APPROVED:
      return 'Commandes validées';
    case ORDER_STATUS_FACTURED:
      return 'Commandes facturées';
    case STATUS_ORDER_DELIVERED:
      return 'Commandes livrées';
    case CART_STATUS_CURRENT:
      return 'Paniers en cours';
    case PREORDER_STATUS_APPROVED:
      return 'Précommandes validées';
    case CART_STATUS_CURRENT_PREORDER:
      return 'Paniers en cours';
    case CART_STATUS_MOQ_STAND_BY:
      return 'Précommandes à valider';
    case STATUS_CREDIT:
      return "Demandes d'avoir";
    case CART_STATUS_MOQ_PREORDER:
      return userType === TYPE_CUSTOMER ? 'Précommandes à valider' : 'MOQ à valider';
    case ORDER_FACTURED_ITEMS:
      return 'RÉFÉRENCES FACTURÉES';
    default:
      return '';
  }
}
